angular.module('picmonic-common').factory('ngBowser', [
  function () {
    bowser = bowser.getParser(window.navigator.userAgent);
    platform = bowser.getPlatform();
    os = bowser.getOS();
    browser = bowser.getBrowser();
    return {
      bowser: bowser,
      platform: platform,
      os: os,
      browser: browser,
      isDesktop: function () {
        return this.platform.type === 'desktop';
      },
      isMobile: function () {
        return this.platform.type === 'mobile';
      },
      isTablet: function () {
        return this.platform.type === 'tablet';
      },
      isIOS: function () {
        return this.os.name === 'iOS';
      },
      isAndroid: function () {
        return this.os.name === 'Android';
      },
      getPlatformType: function () {
        return this.platform.type === 'mobile' ? 'mobile-web' : this.platform.type;
      },
    };
  },
]);
